// export * from './hub-components/hub-components.module'
// export * from './hub-components/mocks'

import { NgModule, ModuleWithProviders } from '@angular/core'
import { RouterModule } from '@angular/router'

import { HubComponentsModule } from './hub-components.module'

import * as $ from 'jquery'

@NgModule({
  imports: [HubComponentsModule],
  exports: [HubComponentsModule],
})
export class HubComponentsTestModule {
  public static forRoot(): ModuleWithProviders<HubComponentsTestModule> {
    return {
      ngModule: HubComponentsTestModule,
      providers: [
        ...HubComponentsModule.forRoot().providers,
        ...RouterModule.forRoot([], {}).providers,
      ]
    }
  }
}
